import {PAGE_OPT, SEARCH_OPT} from "../config/ResourcesConfig.js";
import {rendererPageInfo} from "../../util/Page.js";
import * as UIUtil from "../../util/UI.js";
import {getResourcesList, getFeaturedResource} from "../api/ResourcesApi.js";
import {getActiveMenuKey, getKeyMenuByParent, getParentKey, openMenu} from "../../common/Menu.js";

const PAGE = PAGE_OPT.LIST;
const SEARCH = SEARCH_OPT.LIST;
let fullResourcesList = [];

export const open = async function (pushHistory = true) {
    try {
        if (pushHistory && location.hash !== '#Resources') {
            history.pushState({ menuKey: 'Resources' }, '', '#Resources');
        }

        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/prcenter/Resources.html`;

        const headerWrap = document.querySelector(".headerWrap");
        if (!headerWrap) {
            console.error('[Resources] headerWrap not found');
            return;
        }

        // HTML fetch와 데이터 API 호출을 동시에 시작 (네트워크 왕복 1회분 단축)
        PAGE.pageNo = 1;
        const htmlPromise = fetch(htmlUrl).then((res) => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.text();
        });
        const dataPromise = getResourcesList({
            ...SEARCH,
            rowSize: PAGE.pg_rowsize,
            currentPage: PAGE.pageNo
        });
        const featuredPromise = getFeaturedResource();

        // HTML 먼저 들어와야 DOM 삽입/이벤트 초기화 가능
        const html = await htmlPromise;
        headerWrap.insertAdjacentHTML("afterend", html);
        initEvent();
        initTabs();
        initSearchEvent();

        // 대표영상 렌더링
        featuredPromise
            .then(renderFeaturedVideo)
            .catch((err) => console.error('[Resources] featured fetch failed', err));

        // 데이터 결과로 그리기 
        const response = await dataPromise;
        if (!response.SUCCESS) {
            UIUtil.msgBox("검색 실패", "error");
            return;
        }

        const { LIST, TOTAL_COUNT } = response.RESULT;
        fullResourcesList = LIST;

        drawListItems(LIST);
        drawTotalCount(TOTAL_COUNT);
        rendererPageInfo({
            ...PAGE,
            domId: ".paginate",
            pdom: ".paginate-wrap",
            totalCount: TOTAL_COUNT
        }, drawList);

    } catch (error) {
        console.error(error);
    }
};

const initEvent = function () {
    const homeElement = document.querySelector('.breadcrumb .home');
    const parentElement = document.querySelectorAll('.breadcrumb li a')[1];

    if (homeElement) {
        homeElement.addEventListener('click', () => {
            openMenu('Main');
        });
    }

    if (parentElement) {
        parentElement.addEventListener('click', () => {
            const currentMenuKey = getActiveMenuKey();
            const parentKey = getParentKey(currentMenuKey);
            const firstChildKey = getKeyMenuByParent(parentKey);
            if (firstChildKey) {
                openMenu(firstChildKey);
            }
        });
    }
}

const drawList = async function (pageNo = 1) {
    PAGE.pageNo = pageNo;

    const param = {
        ...SEARCH,
        rowSize: PAGE.pg_rowsize,
        currentPage: PAGE.pageNo
    };

    const response = await getResourcesList(param);

    if (!response.SUCCESS) {
        UIUtil.msgBox("검색 실패", "error");
        return;
    }

    const { LIST, TOTAL_COUNT } = response.RESULT;
    fullResourcesList = LIST;

    drawListItems(LIST);
    drawTotalCount(TOTAL_COUNT);

    const pageOption = {
        ...PAGE,
        domId: ".paginate",
        pdom: ".paginate-wrap",
        totalCount: TOTAL_COUNT
    };

    rendererPageInfo(pageOption, drawList);
};

const drawListItems = function (items) {
    const listEl = document.querySelector(".grid-layout-area.data");
    if (!listEl) return;

    listEl.innerHTML = "";

    if (!items || items.length === 0) {
        listEl.innerHTML = `<div class="empty">등록된 홍보자료가 없습니다.</div>`;
        return;
    }

    items.forEach((item) => {
        const videoUrl = item.videoUrl || item.youtubeUrl;
        const isVideo = item.type === 'video' || (!item.type && !!videoUrl);
        const iconClass = isVideo ? 'play' : 'down';
        const imgHtml = item.resourcesImgId
            ? `<img src="/resources/file/view/${item.resourcesImgId}" alt="">`
            : '';

        const a = document.createElement("a");
        a.className = "box";
        a.href = "javascript:void(0)";

        a.innerHTML = `
            <div class="img-cnt ${iconClass}">
                ${imgHtml}
            </div>
            <div class="tit-cnt">
                <div class="tit">${item.title ?? ''}</div>
                <div class="cte-cnt">
                    <span class="date">${item.registerDate ?? ''}</span>
                </div>
            </div>
        `;

        a.addEventListener("click", (e) => {
            e.preventDefault();
            if (isVideo) {
                if (!videoUrl) {
                    UIUtil.msgBox("영상 주소가 없습니다.", "error");
                    return;
                }
                openYoutubeModal(videoUrl, item.title ?? '');
            } else {
                if (!item.resourcesFileId) {
                    UIUtil.msgBox("파일이 없습니다.", "error");
                    return;
                }
                window.open(`/resources/file/download/${item.resourcesFileId}`, '_blank', 'noopener');
            }
        });

        listEl.appendChild(a);
    });
};

const toEmbedUrl = function (url) {
    try {
        const u = new URL(url);
        if (u.hostname.includes('youtu.be')) {
            const id = u.pathname.replace('/', '');
            return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
        }
        if (u.hostname.includes('youtube.com')) {
            if (u.pathname.startsWith('/embed/')) return `${url}${url.includes('?') ? '&' : '?'}autoplay=1&rel=0`;
            const id = u.searchParams.get('v');
            if (id) return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
        }
    } catch (_) { /* fall through */ }
    return url;
};

const renderFeaturedVideo = function (response) {
    const playerEl = document.querySelector(".contents-wrap.pr .player-content");
    if (!playerEl) return;

    const item = response?.SUCCESS ? response.RESULT : null;
    const videoUrl = item?.videoUrl || item?.youtubeUrl;
    // 사용자 진입 시점에는 브라우저 자동재생 정책상 mute=1 필요
    if (!videoUrl) {
        playerEl.style.display = "none";
        return;
    }

    const embedUrl = `${toEmbedUrl(videoUrl)}&mute=1&playsinline=1`;
    playerEl.innerHTML = `
        <iframe src="${embedUrl}" title="${item.title ?? ''}" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    `;
    playerEl.style.display = "";
};

// 퍼블이 없어서 임시로 인라인으로 모달 만듬 iframe
const openYoutubeModal = function (url, title) {
    closeYoutubeModal();

    const embedUrl = toEmbedUrl(url);
    const overlay = document.createElement('div');
    overlay.id = 'resources-video-modal';
    overlay.setAttribute('style', `
        position:fixed; inset:0; background:rgba(0,0,0,0.85);
        display:flex; align-items:center; justify-content:center;
        z-index:9999; padding:20px;
    `);
    overlay.innerHTML = `
        <div style="position:relative; width:100%; max-width:960px;">
            <button type="button" aria-label="close"
                style="position:absolute; top:-40px; right:0; width:32px; height:32px;
                       background:transparent; border:0; color:#fff; font-size:28px;
                       line-height:1; cursor:pointer;">&times;</button>
            <div style="position:relative; width:100%; padding-top:56.25%; background:#000;">
                <iframe src="${embedUrl}" title="${title || ''}"
                    style="position:absolute; inset:0; width:100%; height:100%; border:0;"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </div>
    `;

    overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeYoutubeModal();
    });
    overlay.querySelector('button')?.addEventListener('click', closeYoutubeModal);

    document.addEventListener('keydown', escListener);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
};

const escListener = function (e) {
    if (e.key === 'Escape') closeYoutubeModal();
};

const closeYoutubeModal = function () {
    const overlay = document.getElementById('resources-video-modal');
    if (overlay) overlay.remove();
    document.removeEventListener('keydown', escListener);
    document.body.style.overflow = '';
};

const initTabs = function () {
    const tabLinks = document.querySelectorAll(".tabArea .subtabs li a");
    if (!tabLinks.length) return;

    tabLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
            e.preventDefault();
            const li = link.parentElement;
            if (!li || li.classList.contains("on")) return;

            document.querySelectorAll(".tabArea .subtabs li").forEach(item => item.classList.remove("on"));
            li.classList.add("on");

            const type = link.dataset.type || null;
            SEARCH.type = type;

            drawList(1);
        });
    });
};

const drawTotalCount = function (count) {
    const strong = document.querySelector(".tabArea .contents > .total strong");
    if (strong) strong.textContent = count ?? 0;
};

const initSearchEvent = function () {
    const searchInput = document.querySelector(".search-box input[type='search']");
    const searchBtn = document.querySelector(".search-box button");

    if (!searchInput || !searchBtn) return;

    searchBtn.addEventListener("click", function () {
        const keyword = searchInput.value.trim();
        SEARCH.searchValue = keyword;

        drawList(1);
    });

    searchInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") {
            searchBtn.click();
        }
    });
};
